export const ACTIVE_SESSION_KEY = 'isInActiveSession';
